import { render, staticRenderFns } from "./VsmReloadButton.vue?vue&type=template&id=d2324b20&"
import script from "./VsmReloadButton.vue?vue&type=script&lang=js&"
export * from "./VsmReloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports